import React from 'react'
import { SiteWizardContext } from '../SiteWizard.js'
import { Label, TextInput } from '@nike/epic-react-ui'
import { Field, ValidationError } from '__components'
import { integer, required } from '__util/forms/validators.js'
import { useRealOrMockContext } from '__util/test-helpers'

export default function Port({ name, stepName }) {
  const { registerField, setField, state } = useRealOrMockContext(SiteWizardContext)
  const { errors, fields } = state

  React.useEffect(
    () => registerField(stepName, name, [required(), integer()], 22),
    [registerField, name, stepName]
  )

  return (
    <Field>
      <Label label='Port' required>
        <TextInput
          hasErrors={errors[name]}
          onChange={(e) => setField(name, e.target.value)}
          value={fields[name] || ''}
        />
        <ValidationError message={errors[name]} />
      </Label>
    </Field>
  )
}
